import { faClock } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useCallback } from "react";

const OrderCard = ({ order }: any) => {
  const getDeliverTypeName = useCallback((type: number) => {
    switch (type) {
      case 0:
        return "تحویل در رستوران";
      case 1:
        return "تحویل در محل";
    }
  }, []);

  const getPayTypeName = useCallback((type: string) => {
    switch (type) {
      case "1":
        return "نقدی";
      case "2":
        return "کارتخوان";
      case "3":
        return "آنلاین";
    }
  }, []);

  return (
    <div className=' shadow my-2 rounded'>
      <div className='bg-rose-900 p-2 text-white rounded-t-lg flex'>
        <div className='flex-1'>{getDeliverTypeName(order.deliverType)}</div>
        <div className='flex-1 text-left'>
          <FontAwesomeIcon
            icon={faClock}
            className='ml-1 '
          />
          {order.created_at}
        </div>
      </div>

      <div className='p-2 flex items-center'>
        <div className='flex-1 text-center'>
          <div>سفارش شماره </div>
          <div className='text-gray-500'>{order.no}</div>
        </div>

        <div className='flex-1 text-center'>
          <div>هزینه</div>
          <div className='text-gray-500'>
            {new Intl.NumberFormat("fa-IR").format(order.cost)} ریال
          </div>
        </div>

        <div className='flex-1 text-center'>
          <div> نحوه پرداخت </div>
          <div className='text-gray-500'>{getPayTypeName(order.payType)}</div>
        </div>
      </div>
      <div>
        {order.meals.map((food: any) => (
          <div className='rounded border-t p-2 flex'>
            <div className='flex-1'>{food.name}</div>
            <div>{food.count} عدد</div>
          </div>
        ))}
      </div>
      <div className='bg-gray-200 border-t p-2 rounded-b-lg'>
        آدرس تحویل :{" "}
        {order.deliverType === 0
          ? "حضوری"
          : order.address[0]
          ? order.address[0].address
          : "-"}
      </div>
    </div>
  );
};

export default OrderCard;
